// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import * as SequentCore from "sequent-core";
import { createLocalValidator } from "./localValidator";
/** The local validator backed by the portal's sequent-core WebAssembly module. */
export var sequentCoreValidator = function (kind, options) { return createLocalValidator(SequentCore, kind, options); };
